import { IonButton } from "@ionic/react";
import { ComponentProps, Ref } from "react";

import styles from "@components/buttons/Button.module.css";
import { Colors } from "@utils/colorUtils";

type Props = Omit<ComponentProps<typeof IonButton>, "color" | "mode" | "shape" | "size"> & {
  color?: Colors;
  forwardRef?: Ref<HTMLIonButtonElement>;
  resizeOnMobile?: boolean;
  size?: Extract<ComponentProps<typeof IonButton>["size"], "default" | "large">;
};

const Button = ({ className, forwardRef, resizeOnMobile = true, size, ...props }: Props) => {
  const classNames = [styles.button];
  if (className) {
    classNames.push(className);
  }
  if (size) {
    classNames.push(styles[size]);
  }
  if (resizeOnMobile) {
    classNames.push(styles.resizeOnMobile);
  }

  return (
    // eslint-disable-next-line react/forbid-elements
    <IonButton color="primary" {...props} className={classNames.join(" ")} mode="md" ref={forwardRef} shape="round" />
  );
};
export default Button;
